import z from "zod";

export const languages = ["hu", "en"] as const;

export const language = z.enum(languages);

export type Language = z.infer<typeof language>;

export const defaultLanguage: Language = "hu";

export const placeholderImageUrl = "/images/placeholder.png";
